import {PaylinkSubscription} from '../models/paylink-subscription';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../services/global-loader.service';
import {Router, RouterModule} from '@angular/router';
import {EnvironmentService} from '../services/environment.service';
import {ApiAgentService} from '../services/api-agent.service';
import {MyBusiness} from '../models/my-business';
import {PartnerMerchantRelationshipRequest} from '../models/connect-merchant-with-partner-request';
import {Partner} from '../models/partner';
import {MerchantPackage} from '../models/merchant-package';
import {EventBusService} from '../services/event-bus.service';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule, NgOptimizedImage} from '@angular/common';

export function decodeBase64(base64String: string): string {
  return atob(base64String);
}

declare var $: any;
declare var App: any;

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, NgOptimizedImage],
  styleUrls: ['./private.component.scss']
})
export class PrivateComponent implements OnInit {

  constructor(private loader: GlobalLoaderService,
              private router: Router,
              private eventBus: EventBusService,
              private api: ApiAgentService,
              public env: EnvironmentService) {
  }

  @ViewChild('sidebar') sidebar: ElementRef;
  @ViewChild('trustedMerchantModal') trustedMerchantModal: ElementRef;

  scriptsLoaded: boolean;
  businessModel: MyBusiness;
  partnerConnectionsRequest: PartnerMerchantRelationshipRequest[];
  myPartners: Partner[];
  currentLang: string;

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  // New properties for controlling the visibility of the CTA buttons
  showRenewButton = false;
  showUpgradeButton = false;

  checkPermission() {
    let perms = this.env.checkPermission(this.businessModel.subAccountType, this.businessModel.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  async ngOnInit() {
    await this.loadResources();

    this.eventBus.registerRefreshMyBusiness().subscribe((myBusiness: any) => {
      console.log('refreshMyBusiness event received', myBusiness);
      this.refreshMyBusiness(myBusiness);
    });

    this.currentLang = localStorage.getItem('lang');
    // this.businessModel = await this.api.getMyLightBusiness();
    this.businessModel = await this.api.getMyBusiness(false);
    console.log('my business loaded with value', this.businessModel);

    this.checkPermission();


    this.checkCtaButtonsVisibility().then();

    if (this.businessModel != null && (this.isMerchant || this.isManager)) {

      this.api.getCheckPartnerConnections().then(value => {
        console.log('partner connections requests', value);
        if (value) {
          this.partnerConnectionsRequest = value.filter((value1, index) => value1.relationshipStatus == 'PendingMerchantApproval');
        }
      });
    }

    if (this.businessModel != null && this.businessModel.subAccountGovId == null) {
      this.api.getMyPartners().then(value => {
        console.log('my partner', value);
        this.myPartners = value;
      });
    }

    setInterval(() => {
      this.checkCtaButtonsVisibility();
    }, 60000);
  }

  async checkCtaButtonsVisibility() {
    // New logic to check if the package is free and set the visibility of the Upgrade button
    let isFree = this.isFreePackage(this.businessModel.paylinkSubscription);
    this.showUpgradeButton = isFree && !this.businessModel.hasPartner && !this.businessModel.hasPartner && !this.businessModel.paylinkSubscription.isSpecialPackage;
    console.log('show upgrade button', this.showUpgradeButton);

    // New logic to check if the subscription is ending soon and set the visibility of the Renew button
    const daysToSubscriptionEnd = this.calculateDaysToEnd(this.businessModel.merchantPackage);
    console.log('days to subscription end', daysToSubscriptionEnd);
    this.showRenewButton = daysToSubscriptionEnd <= 30 && !this.businessModel.hasPartner && !isFree && !this.businessModel.hasPartner && !this.businessModel.paylinkSubscription.isSpecialPackage;
    console.log('show renew button', this.showRenewButton);
  }

  async refreshMyBusiness(myBusiness: MyBusiness) {
    console.log('reached to refreshMyBusiness');
    console.log('my business is', myBusiness);
    if (myBusiness == null) {
      this.api.getMyBusiness(true).then(value => {
        console.log('my business loaded with value line 109', value);
        this.businessModel = value;
        this.checkCtaButtonsVisibility().then();
      });
    } else {
      this.businessModel = myBusiness;
      this.checkCtaButtonsVisibility().then();
    }
  }

  changeLang() {
    if (window.localStorage.getItem('lang') == 'ar') {
      window.localStorage.setItem('lang', 'en');
      window.location.reload();
    } else {
      window.localStorage.setItem('lang', 'ar');
      window.location.reload();
    }
  }

  logout() {
    localStorage.removeItem('token');
    sessionStorage.removeItem('myBusiness');
    this.router.navigate(['auth/login']).then();
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/loader.css');
    await this.loader.loadExternalStyles('/bootstrap/css/bootstrap.min.css');
    await this.loader.loadExternalStyles('/assets/css/plugins.css');
    await this.loader.loadExternalStyles('/styles.css');
    await this.loader.loadExternalScript('/assets/js/libs/jquery-3.1.1.min.js');
    await this.loader.loadExternalScript('/bootstrap/js/popper.min.js');
    await this.loader.loadExternalScript('/bootstrap/js/bootstrap.min.js');
    await this.loader.loadExternalScript('/plugins/perfect-scrollbar/perfect-scrollbar.min.js');
    await this.loader.loadExternalScript('/plugins/perfect-scrollbar/perfect-scrollbar.min.js');
    await this.loader.loadExternalScript('/assets/js/app.js');
    await this.loader.loadExternalScript('/assets/js/custom.js');
    $('#load_screen').remove();
    App.init();
    this.scriptsLoaded = true;
  }

  // toggleBurgerMenu() {
  //   const menu = document.getElementById('sidebar-menu');
  //   console.log('menu is', menu);
  //   console.log('side bar native', this.sidebar.nativeElement);
  //   console.log('menu display', menu.style.display);
  //   if (menu.style.display === 'none' || menu.style.display === '') {
  //     menu.style.display = 'block';
  //   } else {
  //     menu.style.display = 'none';
  //   }
  // }

  // New helper method to calculate the number of days until the subscription ends
  private calculateDaysToEnd(mp: MerchantPackage): any {
    console.log('calculating days to end', mp);
    if (mp == null || mp.endDate == null) {
      return '';
    }
    let end = new Date(mp.endDate);
    const today = new Date();
    const diffTime = Math.abs(end.getTime() - today.getTime());

    console.log('diff time', diffTime);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  private isFreePackage(ps: PaylinkSubscription): boolean {
    if (ps == null) {
      return false;
    }
    return ps.monthlyFees == 0 && ps.yearlyFees == 0 && ps.setupFees == 0;
  }

  // New method to handle the "Renew Subscription" button click
  renewSubscription() {
    console.log('Renew Subscription Clicked');
    // Logic to renew the subscription
    this.router.navigate(['private', 'renew-subscription']).then();
  }

  // New method to handle the "Upgrade Subscription" button click
  upgradeSubscription() {
    console.log('Upgrade Subscription Clicked');
    // Logic to upgrade the subscription
    // http://localhost:4201/private/choose-subscription
    this.router.navigate(['private', 'choose-subscription']).then();
  }

  openTrustedModal() {
    $(this.trustedMerchantModal.nativeElement).modal('show');
  }
}
